import useHomeType from 'hooks/useHomeType'
import TabBar from './TabBar'

export const TabBarWrapper = (props: any) => {
  const { hasRota } = useHomeType()

  return <TabBar {...props} hasRota={hasRota} />
}
